const post = {
  slug: "whats-new-2-6-0",
  title: "What's New in Goal Guru 2.6.0",
  category: "Product Updates",
  date: "Jul 11, 2026",
  readTime: "4 min read",
  excerpt:
    "Goal Guru 2.6.0 introduces all-new Team Pages, side-by-side Team Comparison, an in-app Community Chat, smarter standings, and a wave of quality-of-life upgrades.",
  content: [
    "Goal Guru 2.6.0 is rolling out now on iOS and Android, and it's one of our biggest updates yet. This release is all about teams: dedicated team profiles, side-by-side comparisons, better ways to follow your favorites — plus a brand-new community chat to talk football with other fans. Here's everything that's new.",

    "## 🏟️ All-New Team Pages",

    "Dive into any team's full profile: recent form, squad, live standings, detailed stats, and upcoming fixtures — all in one place. Whether you're checking how your club has been performing or scouting an upcoming opponent, the new Team Pages bring every relevant number together so you don't have to jump between screens.",

    "## ⚖️ Team Comparison",

    "Put two teams side by side and see exactly how they stack up. Attacking output, defensive record, form, and more — compared directly, so the differences are obvious at a glance instead of buried in separate stat sheets.",

    "## ⭐ Follow Your Favorite Teams",

    "Favorite teams right from Match Details and get notified about the moments that matter. Your favorite leagues, teams, and today's matches now live together on one screen — a single personalized home for the football you actually follow.",

    "## 💬 Community Chat",

    "Talk football with other fans in a brand-new in-app chat room. Share your read on a match as it happens, discuss results, or just hang out with people who watch the game the way you do. Community Chat comes with simple ground rules and in-app reporting to keep the conversation enjoyable for everyone — see our updated [Terms & Conditions](/terms-conditions/) for the details.",

    "## 📊 Smarter Standings",

    "Expand any league table to reveal promotion and relegation zones, plus the rules behind them. No more guessing what finishing seventh actually means — the table now tells you.",

    "## 🔄 Head-to-Head, Reimagined",

    "See both teams' last results side by side, so you can compare form at a glance before a fixture. The redesigned head-to-head view makes pre-match context faster to read than ever.",

    "## 🧭 Faster Navigation",

    "A new Home button gets you back to the start in one tap, no matter how deep you've navigated. Fewer taps, more football.",

    "## 🌙 Easier on the Eyes",

    "Dark mode colors have been tuned down so bright accents no longer glare against black backgrounds. Late-night match tracking just got more comfortable.",

    "## 🔔 Smarter Alerts",

    "Tap a [backtest](/blog/backtesting-smart-alerts/)-complete notification and jump straight to your report. The path from 'your analysis is ready' to actually reading it is now a single tap.",

    "## Update Now",

    "Goal Guru 2.6.0 is available today on the App Store and Google Play. Update the app to explore the new Team Pages, run your first Team Comparison, and say hello in Community Chat — and as always, let us know what you think at support@goalguru.live.",
  ],
};

export default post;
